import { GraphOptions, serializeGraphOptions } from '../src/graph/options';

export type EmbedFormat = 'markdown' | 'html' | 'url';

/** Absolute `/api/graph` URL carrying every non-default setting. */
export const buildGraphUrl = (origin: string, options: GraphOptions): string => {
    const params = serializeGraphOptions(options).toString();
    return `${origin}/api/graph?${params}`;
};

export const buildSnippet = (format: EmbedFormat, url: string, altText: string): string => {
    switch (format) {
        case 'markdown':
            return `![${altText}](${url})`;
        case 'html':
            return `<img src="${url.replace(/&/g, '&amp;').replace(/"/g, '&quot;')}" alt="${altText}" />`;
        case 'url':
            return url;
    }
};
